import React, { useEffect, useRef } from 'react';
import { Button, Input } from '@byte-design/ui';
import { observer, useLocalStore } from 'mobx-react';
import './index.css';
import { useTranslation } from 'react-i18next';

interface Props {
  onChange: (val: string) => void;
  onClose: () => void;
  x: number;
  y: number;
}
function LinkInput({
  onChange, onClose, x, y,
}: Props) {
  const ref = useRef(null);
  const { t } = useTranslation();
  const State = useLocalStore(() => ({
    value: '',
  }));
  const left = `${Math.min((document.body.clientWidth - 330), x < 0 ? 0 : x)}px`;
  const top = `${y}px`;

  useEffect(() => {
    setTimeout(() => {
      (ref.current as any).focus();
    }, 0);
  }, []);

  return (
    <div
      className="link_group_container"
      onClick={onClose}
    >
      <Input.Group
        className="link_group"
        style={{ top, left }}
      >
        <Input
          style={{ width: '240px' }}
          onValueChange={(val) => { State.value = val; }}
          value={State.value}
          inputRef={ref}
          clearable
        />
        <Button
          type="primary"
          style={{ minWidth: '60px' }}
          onClick={(e: any) => {
            e.stopPropagation();
            onChange(State.value);
          }}
        >
          {t('comfirm')}
        </Button>
      </Input.Group>
    </div>
  );
}

export default React.memo(observer(LinkInput));
